import React from 'react';
import ProfilePage from './profile/ProfilePage';

const Profile = () => <ProfilePage />;

export default Profile;
